import * as React from "react";
import PreviewLakeLogsButton from "./PreviewLakeLogsButton";
const PreviewExternalLakeLogsButton = ({
  bsStyle,
  bsSize,
  target,
  children,
  tableId = void 0,
  dataLakeId,
  onClick
}) => /* @__PURE__ */ React.createElement(
  PreviewLakeLogsButton,
  {
    bsStyle,
    bsSize,
    target,
    dataLakeId,
    onClick,
    urlParams: tableId ? `streams=${tableId}` : void 0
  },
  children
);
export default PreviewExternalLakeLogsButton;
